import React from 'react';
import PropTypes from 'prop-types';

export interface CroppedImageViewProps {
  originalWidth: number;
  // eslint-disable-next-line react/no-unused-prop-types
  originalHeight?: number | null;
  resizeImageHeight: number;
  aspectRatio: number;
  src: string;
  SourceWidth?: number | null;
  // eslint-disable-next-line react/no-unused-prop-types
  SourceHeight?: number | null;
  SourceX?: number | null;
  SourceY?: number | null;
  borderRadius?: number | null;
  styleOverride?: React.CSSProperties;
}

export class CroppedImageView extends React.PureComponent<CroppedImageViewProps> {
  render() {
    const {
      originalWidth,
      resizeImageHeight,
      aspectRatio,
      src,
      styleOverride,
    } = this.props;

    const SourceWidth = this.props.SourceWidth || originalWidth;
    const SourceX = this.props.SourceX || 0;
    const SourceY = this.props.SourceY || 0;
    const borderRadius = this.props.borderRadius || 0;

    const resizeImageWidth = resizeImageHeight * aspectRatio;

    const imageToContainerRatio = resizeImageWidth / originalWidth;

    const cropSectionToImageRatio = originalWidth / SourceWidth;

    const negativeMarginX = -SourceX * imageToContainerRatio * cropSectionToImageRatio;
    const negativeMarginY = -SourceY * imageToContainerRatio * cropSectionToImageRatio;

    const resizeContainerStyle = {
      height: `${resizeImageHeight}px`,
      width: `${resizeImageWidth}px`,
      overflow: 'hidden',
      borderRadius: `${borderRadius}px`,
      ...styleOverride, // Allow external style overrides
    };

    const resizeImageStyle = {
      width: `${resizeImageWidth * cropSectionToImageRatio}px`,
      marginLeft: `${negativeMarginX}px`,
      marginTop: `${negativeMarginY}px`,
    };

    return (
      <div
        className="cropped-image-view"
        style={resizeContainerStyle}
      >
        <img
          onContextMenu={e => e.preventDefault()}
          style={resizeImageStyle}
          src={src}
          alt={aspectRatio as unknown as string}
        />
      </div>
    );
  }
}

(CroppedImageView as React.ComponentClass<CroppedImageViewProps>).propTypes = {
  originalWidth: PropTypes.number.isRequired,
  resizeImageHeight: PropTypes.number.isRequired,
  aspectRatio: PropTypes.number.isRequired,
  SourceWidth: PropTypes.number,
  SourceX: PropTypes.number,
  SourceY: PropTypes.number,
  src: PropTypes.string.isRequired,
  borderRadius: PropTypes.number,
  styleOverride: PropTypes.shape({}),
};

(CroppedImageView as React.ComponentClass<CroppedImageViewProps>).defaultProps = {
  SourceWidth: null,
  SourceX: null,
  SourceY: null,
  borderRadius: null,
  styleOverride: {},
};
